<template>
  <div class="dispute-assignee__modal">
    <Modal
      :active="true"
      :primary-button-disabled="!enableApplybutton || disputeModalLoading"
      tertiary-button-label="Cancel"
      primary-button-label="Apply"
      size="small"
      :close-on-click-outside="false"
      @onClose="onClose()"
      @onConfirm="saveModalChanges()">
      <template #header>
        <p>Update Assignee</p>
      </template>
      <template #content>
        <div class="dispute-assignee__modal__body">
          <div v-if="isBulk" class="dispute-assignee__modal__body__selected">
            <span class="dispute-assignee__modal__body__selected__header">
              Selected disputes
            </span>
            <span class="dispute-assignee__modal__body__selected__content">{{
              getOhpDisputeIds()
            }}</span>
          </div>
          <div class="dispute-assignee__modal__body__grid">
            <DropdownSearch
              label="Assignee name"
              placeholder="Select a user as Assignee"
              variant="small"
              :from-assignee-form="true"
              :value="assigneeNameValue"
              :has-error="hasNameError"
              :error-message="errorMessage"
              @handleFilterChange="onNameChange($event)"
              @submitState="onSubmitState($event)" />
          </div>
          <div class="dispute-assignee__modal__body__editor">
            <p class="dispute-assignee__modal__body__editor__justification">
              Comments
            </p>
          </div>
          <div class="dispute-assignee__modal__body__content">
            <text-editor
              :default-comments="defaultComments"
              :max-length="4000"
              :error="hasEditorError"
              error-msg="Comments supports maximum 4000 characters."
              @commentsChange="handleCommentsText" />
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
// Components
import TextEditor from "@/components/common/TextEditor/TextEditor.vue";
import DropdownSearch from "@/components/common/DropdownSearch/DropdownSearch.vue";

export default {
  name: "DisputeAssigneeModal",
  components: {
    DropdownSearch,
    TextEditor,
  },
  props: {
    disputeModalLoading: {
      type: Boolean,
      default: false,
    },
    isBulk: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    bulkData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      assigneeNameValue: this.data.disputeAgentApmId
        ? { apmId: this.data.disputeAgentApmId }
        : {},
      comments: "",
      defaultComments: `<p class="question"></p>`,
      errorMessage: "Assignee name is required!",
      enableApplybutton: false,
      hasNameError: false,
      hasEditorError: false,
    };
  },
  methods: {
    onClose() {
      this.$emit("onModalClose");
    },
    handleCommentsText({ html }) {
      this.hasEditorError = false;
      this.comments = html;
    },
    onNameChange(options) {
      const { value } = options;
      if (value) {
        this.hasNameError = false;
        this.enableApplybutton = true;
      } else {
        this.enableApplybutton = false;
      }
      this.assigneeNameValue = value;
    },
    onSubmitState({ value }) {
      this.submitChangesError = value;
    },
    saveCommentsCallback(comments, successIds) {
      const commentHTML = document.createElement("p");
      commentHTML.innerHTML = comments;
      const commentsText = commentHTML.textContent.trim();
      if (commentsText) {
        if (!this.isBulk) {
          this.$emit(
            "saveComments",
            { commentText: commentsText, commentHtml: this.comments },
            { ohpDisputeId: this.data.ohpDisputeId }
          );
        } else {
          this.$emit("saveBulkComments", {
            ohpDisputeIds: successIds,
            commentText: commentsText,
            commentHtml: this.comments,
          });
        }
      }
    },
    saveModalChanges() {
      if (this.comments.length > 4000) {
        this.hasEditorError = true;
        return;
      }
      if (!this.isBulk) {
        const payload = [
          {
            disputeStage: this.data.disputeStage,
            ohpDisputeId: this.data.ohpDisputeId,
            disputeAgentApmId: this.assigneeNameValue?.apmId,
            disputeAgentName: this.assigneeNameValue?.userName,
            processInstanceId: this.data.wfProcessId,
          },
        ];
        this.$emit("updateAssigneeForm", payload, () =>
          this.saveCommentsCallback(this.comments)
        );
      } else {
        const payload = this.bulkData.map((item) => {
          return {
            disputeStage: item.disputeStage,
            ohpDisputeId: item.ohpDisputeId,
            disputeAgentApmId: this.assigneeNameValue?.apmId,
            disputeAgentName: this.assigneeNameValue?.userName,
            processInstanceId: item.wfProcessId,
          };
        });
        this.$emit("updateBulkAssigneeForm", payload, (successIds) =>
          this.saveCommentsCallback(this.comments, successIds)
        );
      }
    },
    getOhpDisputeIds() {
      return this.bulkData
        .map((item) => {
          return item.ohpDisputeId;
        })
        .join(", ");
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/imports";

.dispute-assignee__modal {
  .modal--small {
    height: 500px;
    width: 500px;
  }
  & .p-page__modal__window__content {
    padding-top: 0;
  }
  &__body {
    &__selected {
      &__header {
        display: block;
        font-family: "Maersk Text Bold";
      }
      &__content {
        display: block;
        margin-bottom: 1rem;
      }
    }
    &__grid {
      .vs__dropdown-toggle {
        width: 452px;
      }
      .vs__dropdown-menu {
        width: 452px;
      }
    }
    &__editor {
      margin: 1rem 0 0.5rem 0;
      &__justification {
        display: inline;
        margin-right: 0.5rem;
      }
    }
  }
}
</style>
